import { StandardAction, createLogic } from "redux-logic";
import { IOperatorInstructionModel } from "../../interfaces/OperatorInstruction/IOperatorInstructionModel";
import { IWarningModalModel } from "../../interfaces/WarnigModal/IWarningModalModel";
import { SET_CURRENT_INSTRUCTION, SET_WARNING_MODAL } from "../types/InstructionStateTypes";

const setInstructionLogic = createLogic({
  type: SET_CURRENT_INSTRUCTION,
  process(
    { action }: { action: StandardAction<string, IOperatorInstructionModel, () => void> },
    dispatch,
    done
  ) {
    if (action.payload.visible) {
      action.meta();
    }
    done();
  },
});

const setWarningModalLogic = createLogic({
  type: SET_WARNING_MODAL,
  process(
    {
      action,
    }: {
      action: StandardAction<
        string,
        IWarningModalModel,
        (message: string, error: string, header: string) => void | undefined
      >;
    },
    dispatch,
    done
  ) {
    if (typeof action.meta === "function") {
      const warningModal = action.payload;
      action.meta(warningModal.message, warningModal.errorCode, warningModal.header);
    }
    done();
  },
});

export { setInstructionLogic, setWarningModalLogic };
